import customAxios from "./axiosConfig";

const InvoiceUploadService = {
  upload (data) {
    const api_url = window.Urls['invoice-list']()
    const custom_headers = { headers: { 'Content-Type': 'multipart/form-data' } }

    const sent_data = data
    // remove empty fields
    for (var i in sent_data) {
      if( i === "invoice_lines"){
        for(var j=0; j<sent_data[i].length; j++){
          for (var k in sent_data[i][j]) {
            if(k === "product"){
              sent_data[i][j]["product_id"] = sent_data[i][j][k];
              delete sent_data[i][j][k];
            }
          }
        }
        continue
      }
      if (sent_data[i] === undefined || sent_data[i] === null) {
        delete sent_data[i]
      }
    }
    
    sent_data.file = sent_data.pdf_file

    // parse form data into formData
    const getFormData = object => Object.keys(object).reduce((formData, key) => {
      if (Array.isArray(object[key])) {
        formData.append(key, JSON.stringify(object[key]))
      } else {
        formData.append(key, object[key])
      }
      return formData
    }, new FormData())

    return customAxios.post(api_url, getFormData(sent_data), custom_headers)
  },
  update (id, data) {
    const api_url = window.Urls['invoice-detail'](id)

    const sent_data = data

    // remove empty fields
    for (var i in sent_data) {
      if (sent_data[i] === undefined || sent_data[i] === null) {
        delete sent_data[i]
      }
    }

    // parse form data into formData
    const getFormData = object => Object.keys(object).reduce((formData, key) => {
      if (Array.isArray(object[key])) {
        formData.append(key, JSON.stringify(object[key]))
      } else {
        formData.append(key, object[key])
      }
      return formData
    }, new FormData())

    return customAxios.put(api_url, getFormData(sent_data))
  },

}

export default InvoiceUploadService;
